import axios from "axios";
import { BaseApi } from "./BaseApi";

export class UsuarioApi extends BaseApi {
    async obterOidFilialUsuarioLogado() : Promise<number> {
        return (await this.api.get(`/Usuario/ObterOidFilialUsuarioLogado`))?.data
    }

    async ObterCodigoFilialUsuarioLogado() : Promise<string> {
        return (await this.api.get(`/Usuario/ObterCodigoFilialUsuarioLogado`))?.data
    }

    async obterUrlLogo(): Promise<string> {
        const urlLogo = (await this.api.get(`/Usuario/ObterUrlLogo`))?.data

        const logoExiste = async () => {
            try {
                await axios.get(urlLogo)
                return true
            } catch (error) {
                return false
            }
        }

        return (await logoExiste()) ? urlLogo : null
    }

    async obterOid():Promise<number> {
        return (await this.api.get(`/Usuario/ObterOidUsuarioLogado`))?.data
    }

    async alterarFonte(nomeGrid:string, tamanho:number) : Promise<void> {
        const response = await this.api.post(`/Usuario/TamanhoFonteGridPeloNome`, {
            tamanho,
            nomeGrid,
            nomeModulo: "Orcamento"
        })
        return response.data
    }
    
}
